/* eslint-disable */
import styled from 'styled-components';
import { flexbox, justifyContent, alignItems } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const HeaderWrapper = styled.div(props => {
    const { colours } = ThemeHelper.getTheme(props);
    
    return `
    ${flexbox()}
    ${alignItems('center')}

    background-color: ${colours.grey['400']};
    padding: 10px 20px;
    `;
})

const MainHeading = styled.div(props => {
    const { typography, palette } = ThemeHelper.getTheme(props);
    return `
    ${flexbox()}

    ${alignItems('center')}
    ${justifyContent('space-between')}
    font-family: ${typography.family};
    color: ${palette.primary.dark};
    font-size: 30px;
    font-weight: 500;
    `;
});

/**
 * @todo Add keppel color to Theme
 */
const SubHeading = styled.div(props => {
    const { colours, palette, typography } = ThemeHelper.getTheme(props);
    return `
    text-align: center;
    padding: 6px 20px;
    margin-left: 20px;
    border: 2px solid ${palette.primary.light};
    border-radius: 20px;
    background-color: ${colours.grey[400]};
    color: ${palette.primary.main};
    font-family: ${typography.family};
    font-size: 15px;
    line-height: 1.2em;
    `;
});

export { HeaderWrapper, MainHeading, SubHeading };



// WEBPACK FOOTER //
// ./app/components/header/styled.js